// QuestionDispenseDrugKit.js
import React from "react";
import {
  QuestionDropdownModel,
  QuestionFactory,
  Serializer,
} from "survey-core";
import {
  ReactQuestionFactory,
  SurveyQuestionElementBase,
} from "survey-react-ui";

const QUESTION_TYPE = "dispenseDrugKit";
let isRegistered = false;

class QuestionDispenseDrugKitModel extends QuestionDropdownModel {
  constructor(name) {
    super(name);

    // Initialize choices array for Survey Creator compatibility
    this.createNewArray("choices");

    // Set default placeholder
    this.placeholder = "Select Drug Kit to Dispense";
  }

  getType() {
    return QUESTION_TYPE;
  }

  get placeholder() {
    return this.getPropertyValue("placeholder", "Select Drug Kit to Dispense");
  }

  set placeholder(val) {
    this.setPropertyValue("placeholder", val);
  }

  // Optional: Add specific properties for dispense functionality
  get requireConfirmation() {
    return this.getPropertyValue("requireConfirmation", false);
  }

  set requireConfirmation(val) {
    this.setPropertyValue("requireConfirmation", val);
  }

  get showQuantity() {
    return this.getPropertyValue("showQuantity", false);
  }

  set showQuantity(val) {
    this.setPropertyValue("showQuantity", val);
  }
}

class SurveyQuestionDispenseDrugKit extends SurveyQuestionElementBase {
  get question() {
    return this.props.question;
  }

  handleChange = (e) => {
    const selectedValue = e.target.value || null;
    this.question.value = selectedValue;

    // Optional: Add custom logic when a drug kit is selected
    if (selectedValue) {
      console.log(`Dispensing drug kit: ${selectedValue}`);
      // You could trigger additional logic here
    }
  };

  renderElement() {
    const q = this.question;
    const value = q.value ?? "";

    return (
      <div style={{ position: "relative" }}>
        <select
          value={value}
          onChange={this.handleChange}
          disabled={q.isReadOnly}
          style={{
            width: "100%",
            boxSizing: "border-box",
            padding: "6px 12px",
            paddingRight: q.showQuantity ? "60px" : "12px",
            borderRadius: "4px",
            border:
              q.errors.length > 0 ? "1px solid #dc3545" : "1px solid #ced4da",
            backgroundColor: q.isReadOnly ? "#e9ecef" : "#fff",
            fontSize: "16px",
            height: "38px",
          }}
        >
          <option value="">{q.placeholder}</option>
          {(q.visibleChoices || q.choices || []).map((choice, index) => (
            <option key={choice.value || index} value={choice.value}>
              {choice.text || choice.value}
            </option>
          ))}
        </select>
      </div>
    );
  }
}

export function registerDispenseDrugKitQuestion() {
  if (isRegistered) return;
  isRegistered = true;

  // Register with Serializer
  Serializer.addClass(
    QUESTION_TYPE,
    [
      {
        name: "placeholder:text",
        category: "general",
        default: "Select Drug Kit to Dispense",
      },
      {
        name: "name",
        type: "text",
        category: "general",
        visible: true,
        isRequired: true,
        isLocalizable: false,
        onSetValue: function (obj, value) {
          obj.setPropertyValue("name", value);
        },
        onGetValue: function (obj) {
          return obj.getPropertyValue("name");
        },
      },
    ],
    () => new QuestionDispenseDrugKitModel(""),
    "dropdown"
  );

  // Register with QuestionFactory
  QuestionFactory.Instance.registerQuestion(
    QUESTION_TYPE,
    (name) => new QuestionDispenseDrugKitModel(name)
  );

  // Register React component
  ReactQuestionFactory.Instance.registerQuestion(QUESTION_TYPE, (props) =>
    React.createElement(SurveyQuestionDispenseDrugKit, props)
  );
}

// Auto-register
registerDispenseDrugKitQuestion();

export default QuestionDispenseDrugKitModel;
